"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
// Getting Hier1 with browser default props
var setAllHier1 = function () {
    var locationPathname = (0, utils_1.removeSpecialCharacters)(window.location.pathname);
    if (locationPathname.split("/").join("|") === "|") {
        return "home";
    }
    return locationPathname
        .replace(/\/$/, "")
        .split("/")
        .join("|")
        .substring(1)
        .replace(".", "-")
        .toLowerCase();
};
exports.default = setAllHier1;
